export default __webpack_public_path__ + "static/media/err-404.d211d4bb.svg";